import { appStore } from "../store/appStore"
import { useRequest } from "./useRequest"
import { getAuthCityId } from "../lib/locationSwitch"
import {
    ensureDeviceToken,
    getDeviceToken,
    isDeviceTokenError,
    refreshDeviceToken,
} from "../lib/deviceToken"

export const useAuth = () => {
    const { request, requestData } = useRequest()
    const { setLastSmsCodeAt, setError } = appStore()

    const checkRegistration = async (phone: string) => {
        const data = await request("GET", `check?phone=${phone}&city_id=${getAuthCityId()}`)
        return data
    }

    const postCode = async (phone: string, type: "sms" | "telegram" | "newtel_call" | undefined, disableError: boolean) => {
        const registered = await checkRegistration(phone)
        const res = await requestData({
            type: "POST",
            path: registered ? "login/code" : "registration/code",
            sendData: {
                phone: `+7${phone}`,
                city_id: getAuthCityId(),
                token: getDeviceToken(),
                type,
            },
            disableError,
        })
        if (res.status === "error") {
            throw new Error(res.error.message)
        }
        return { registered, resData: res.data }
    }

    const sendCode = async (phone: string, type?: "sms" | "telegram" | "newtel_call") => {
        const token = await ensureDeviceToken(requestData)
        if (!token) {
            throw new Error("Не удалось получить идентификатор устройства. Обновите страницу и попробуйте снова.")
        }

        try {
            const result = await postCode(phone, type, true)
            setLastSmsCodeAt(new Date(Date.now() + 60_000).toISOString())
            return result
        } catch (e) {
            const message = e instanceof Error ? e.message : ""
            if (!isDeviceTokenError(message)) {
                setError(message)
                throw e
            }

            const refreshed = await refreshDeviceToken(requestData)
            if (!refreshed) {
                setError(message)
                throw e
            }

            const result = await postCode(phone, type, false)
            setLastSmsCodeAt(new Date(Date.now() + 60_000).toISOString())
            return result
        }
    }

    const checkCode = async (
        code: string,
        registered: boolean,
        phone: string,
        setError?: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        const res = await requestData({
            type: "PUT",
            path: registered ? "login/code" : "registration/code",
            sendData: {
                phone: `+7${phone}`,
                city_id: getAuthCityId(),
                code,
            },
        })
        if (res.status === "success") {
            return res.data
        }
        setError?.(true)
        throw new Error(res.error.message)
    }

    return { sendCode, checkCode }
}
